angular.module('picmonicng').factory('TopicTypesResource', [
  '$resource',
  function ($resource) {
    return $resource(
      '/api/v3/topic_types/:topic_type_id',
      { topic_type_id: '@topic_type_id' },
      {
        update: { method: 'PUT' },
      }
    );
  },
]);
